"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.resolveScopedResolvedValueBindingNode = void 0;
const getResolvedValueNodeBinding_1 = require("../calculations/getResolvedValueNodeBinding");
const resolveScoped_1 = require("./resolveScoped");
const resolveScopedResolvedValueBindingNode = (resolve) => (0, resolveScoped_1.resolveScoped)(getResolvedValueNodeBinding_1.getResolvedValueNodeBinding, resolve);
exports.resolveScopedResolvedValueBindingNode = resolveScopedResolvedValueBindingNode;
//# sourceMappingURL=resolveScopedResolvedValueBindingNode.js.map